import { graphqlApi } from 'src/redux/api/graphql/graphqlApi'
import type { ReduxPurchase } from '@/types/apiType'

export const purchaseApi = graphqlApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchPurchaseById: builder.query({
			query: (id: string) => ({
				queryName: 'getPurchase',
				data: {
					id,
				},
				isList: false,
			}),
			transformResponse: (response: ReduxPurchase) => response,
			providesTags: (_result, _errorr, id) => [{ type: 'Purchase', id }],
		}),
	}),
	overrideExisting: false,
})

export const { useFetchPurchaseByIdQuery } = purchaseApi
